import React from "react";
import ContrastForegroundUtility from "../../../../utils/ContrastForegroundUtility";

interface EndUserDownloadLinkProps {
  href: string;
  primaryColor: string;
}

const EndUserDownloadLink: React.FC<EndUserDownloadLinkProps> = ({
  href,
  primaryColor
}) => (
  <a
    href={href}
    className="geo-lt__cart-icon geo-btn--caps"
    download
    style={{
      background: ContrastForegroundUtility.lbFgColor(primaryColor),
      borderColor: ContrastForegroundUtility.lbFgColor(primaryColor),
      color: "white"
    }}
  >
    <span
      className="fa fa-download"
      style={{ color: "white", marginRight: 8 }}
    />
    <span>Download now</span>
  </a>
);

export default EndUserDownloadLink;
